import React, { ReactNode } from "react";
import ProdutoModel from "../model/ProdutoModel";
import AppState from "../model/AppState";
import CarrinhoItemModel from "../model/CarrinhoItemModel";
import CarrinhoModel from "../model/CarrinhoModel";
import NavegadorUtil from "../util/NavegadorUtil";
import { ReactComponent as ImagemBemQuerer } from "../assets/images/icons/ico_bq.svg";
import LojaModel from "../model/LojaModel";
import { Link } from "react-router-dom";
import ModalMaioridade from "./ModalMaioridade";
import { ObaTipoPromocaoEnum } from "../model/ObaPromocaoModel";


type ProdutosProps = {
  item: ProdutoModel;
  children?: ReactNode;
  parent?: React.Component;
};

type ProdutosState = {
  modalMaioridadeVisivel: boolean;
};

class ProdutoItem extends React.Component<ProdutosProps, ProdutosState> {

  constructor(props: ProdutosProps) {
    super(props);

    this.addItemCarrinho = this.addItemCarrinho.bind(this);
    this.remItemCarrinho = this.remItemCarrinho.bind(this);
    this.carrinhoMensagem = this.carrinhoMensagem.bind(this);
    this.hideMaioridade = this.hideMaioridade.bind(this);
    
    this.state = {
      modalMaioridadeVisivel: false,
    }
  }

  carrinhoMensagem(): string {
    return AppState.carrinhoMensagem(this.props.item.produtoId);
  }

  async addItemCarrinho(): Promise<void> {
    const {item, parent} = this.props;
    
    const loja: LojaModel | null = AppState.getLojaSelecionada();
    if (loja && !loja.retirada) {
      NavegadorUtil.alerta(
        parent,
        "Esta loja não aceita pedidos pelo app.  Favor selecionar outra loja ou dirigir-se até a loja física."
      );
    } else {
      const requerMaioridade = await ProdutoModel.requerMaioridade(item);
      if (requerMaioridade && AppState.getMaioridade() !== true) {
        this.setState({ modalMaioridadeVisivel: true });
      } else {
        let qtd = 1;
        if (item.promo && item.promo.tipo === ObaTipoPromocaoEnum.COMPRE_X_PAGUE_Y) {
          qtd = item.promo.compre;
        }

        for (let x = 0; qtd > x; ++x) {
          // parent?.setState({ carregouProdutos: false });
          try {
            await AppState.addCarrinhoItem(item);
            if (parent && qtd === x + 1) {
              NavegadorUtil.alerta(parent, this.carrinhoMensagem());
              // parent?.setState({ carregouProdutos: true });
            }
          } catch (ex) {
            if (parent && ex) {
              NavegadorUtil.alerta(
                parent,
                ex.replace(/\\n/, " ")
              );
            }
          }
        }
      }
    }
  }

  async remItemCarrinho(): Promise<void> {
    const { item, parent } = this.props;
    
    const loja: LojaModel | null = AppState.getLojaSelecionada();
    if (loja && !loja.retirada) {
      NavegadorUtil.alerta(
        parent,
        "Esta loja não aceita pedidos pelo app.  Favor selecionar outra loja ou dirigir-se até a loja física."
      );
    } else {
      const requerMaioridade = await ProdutoModel.requerMaioridade(item);
      if (requerMaioridade && AppState.getMaioridade() !== true) {
        this.setState({ modalMaioridadeVisivel: true });
      } else {
        AppState.decCarrinhoItem(item).then(() => {
          NavegadorUtil.alerta(parent, this.carrinhoMensagem());
        });
      }
    }
  }

  public getLinkProduto(item: ProdutoModel): string {
    return NavegadorUtil.getUrl(
      `/produto?prodId=${item.produtoId}${
        item.fatorMultiplicacao > 0 ? `&fm=${item.fatorMultiplicacao}` : ''
      }`
    );
  }

  hideMaioridade(): void {
    this.setState({ modalMaioridadeVisivel: false });
    if (AppState.getMaioridade() !== true) {
      NavegadorUtil.alerta(this.props.parent, "Este produto requer maioridade.");
    } else {
      this.addItemCarrinho();
    }
  }

  render(): any {
    const { item } = this.props;
    const { modalMaioridadeVisivel } = this.state;
    const carrinho: CarrinhoModel = AppState.getCarrinho();
    let qtd: number = 0;

    const carrinhoItem: CarrinhoItemModel | undefined = carrinho.carrinhoItens.find(
      (c: CarrinhoItemModel) =>
        c.produto.produtoId === this.props.item.produtoId
    );

    if (carrinhoItem) {
      qtd = carrinhoItem.quantidade;
    }


    let isProdutoBemQuerer: boolean = false;
    const prodsBQ: ProdutoModel[] | null = AppState.getProdutoBemQuerer();
    if (prodsBQ) {
      const prodBQ: ProdutoModel | undefined = prodsBQ.find(
        (p) => p.produtoId === this.props.item.produtoId
      );
      if (prodBQ) {
        isProdutoBemQuerer = true;
      }
    }

    let prodPrecoOriginal: number = item.precoOriginal,
      prodPrecoDesconto: number = item.precoDesconto;

    if (item.unidade === "GR") {
      prodPrecoOriginal = (item.precoOriginal / 1000) * item.fatorMultiplicacao;
      prodPrecoDesconto = (item.precoDesconto / 1000) * item.fatorMultiplicacao;
    }

    return (
      <div className="item" key={item.produtoId}>
        {(item.bemQuerer || isProdutoBemQuerer) && (
          <div className="bemQuerer">
            <ImagemBemQuerer />
          </div>
        )}
        {(item.ff) && (
          <div className="bemQuerer">
            <img src={`${process.env.PUBLIC_URL}/assets/images/badge_fw.svg`} width="60" alt="Fresh weekend" />
          </div>
        )}
        <div className="photo">
          <Link to={this.getLinkProduto(item)} draggable={false}>
            <img
              draggable="false"
              src={item.imagem}
              alt={ProdutoModel.getNome(item)}
              title={ProdutoModel.getNome(item)}
            />
          </Link>
        </div>
        <Link to={this.getLinkProduto(item)} draggable={false}>
          <p className="name">{ProdutoModel.getNome(item)}</p>
        </Link>

        <Link to={this.getLinkProduto(item)} draggable={false}>
          {item.precoDesconto > 0 && item.precoDesconto < item.precoOriginal && (
            <div className="prices-discount">
              <div className="values">
                <p className="original">{`R$ ${prodPrecoOriginal
                  .toFixed(2)
                  .replace(".", ",")}`}</p>
                <p className="current">
                  {`R$ ${prodPrecoDesconto.toFixed(2).replace(".", ",")}`}
                  <span> {ProdutoModel.getGR(item)}</span>
                </p>
                <p className="perKg">
                  &nbsp;
                  {item.unidade === "GR" && (
                    <>
                      R$ {item.precoDesconto.toFixed(2).replace(".", ",")}/Kg{" "}
                    </>
                  )}
                </p>
              </div>
              <div className="discount">
                {`-${(
                  100 -
                  (item.precoDesconto / item.precoOriginal) * 100
                ).toFixed(0)}%`}
              </div>
            </div>
          )}

          {!(
            item.precoDesconto > 0 && item.precoDesconto < item.precoOriginal
          ) && (
            <div className="prices-regular">
              <p className="current">
                {`R$ ${prodPrecoOriginal.toFixed(2).replace(".", ",")}`}
                <span> {ProdutoModel.getGR(item)}</span>
              </p>
              <p className="perKg">
                &nbsp;
                {item.unidade === "GR" && (
                  <>R$ {item.precoDesconto.toFixed(2).replace(".", ",")}/Kg </>
                )}
              </p>
            </div>
          )}
        </Link>

        <div className="qty">
          <button
            className={qtd === 0 ? "zero" : ""}
            onClick={qtd > 0 ? this.remItemCarrinho : () => {} }
          >
            -
          </button>
          <div
            className={`current ${qtd > 0 ? "active" : null}`}
          >
            {qtd}
          </div>
          <button className="more" onClick={this.addItemCarrinho}>
            +
          </button>
        </div>
        { modalMaioridadeVisivel &&
        <ModalMaioridade visivel={true} save={this.hideMaioridade} />
        }
      </div>
    );
  }
}

export default ProdutoItem;
